import React, { useState, useEffect } from 'react';
import { Schemas } from '../lib/schemas';
import { fetchJson } from '../lib/http';
import { Layout } from '../components/Layout';
import { ErrorAlert } from '../components/ErrorAlert';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function SetCredentialsPage() {
	const [activationToken, setActivationToken] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirm, setConfirm] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const fromUrl = searchParams.get('token') || searchParams.get('activation_token');
		if (fromUrl && !activationToken) setActivationToken(fromUrl);
	}, [searchParams, activationToken]);

	async function onSubmit(e: React.FormEvent) {
		e.preventDefault();
		setError('');
		const parsed = Schemas.setCredentials.safeParse({ activation_token: activationToken.trim(), email: email.trim(), password, confirm });
		if (!parsed.success) {
			setError((parsed as any).error?.issues?.[0]?.message || 'Please correct the errors and try again.');
			return;
		}
		setLoading(true);
		try {
			await fetchJson('/portal/set-credentials', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(parsed.data),
			});
			navigate('/custportal/invoices', { replace: true });
		} catch (e: any) {
			if (e?.status === 429) setError('Too many attempts. Please try again in a few minutes.');
			else setError('We could not complete setup. Please check your details and try again.');
		} finally {
			setLoading(false);
		}
	}

	return (
		<Layout>
			<div className="rounded-2xl border border-gray-200 bg-white shadow-sm elev-1 p-6 max-w-lg">
				<h1 className="text-2xl font-extrabold text-gray-900">Set your credentials</h1>
				<form onSubmit={onSubmit} className="mt-6 space-y-4">
					<div>
						<label htmlFor="token" className="block text-sm font-semibold text-gray-700">Activation token</label>
						<input id="token" name="token" autoComplete="off" required value={activationToken} onChange={e => setActivationToken(e.target.value)}
							className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-sedra focus:ring-offset-2" />
					</div>
					<div>
						<label htmlFor="email" className="block text-sm font-semibold text-gray-700">Email</label>
						<input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)}
							className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-sedra focus:ring-offset-2" />
					</div>
					<div>
						<label htmlFor="password" className="block text-sm font-semibold text-gray-700">Password</label>
						<input id="password" name="password" type="password" autoComplete="new-password" required value={password} onChange={e => setPassword(e.target.value)}
							className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-sedra focus:ring-offset-2" />
					</div>
					<div>
						<label htmlFor="confirm" className="block text-sm font-semibold text-gray-700">Confirm password</label>
						<input id="confirm" name="confirm" type="password" autoComplete="new-password" required value={confirm} onChange={e => setConfirm(e.target.value)}
							className="w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-sedra focus:ring-offset-2" />
					</div>
					<ErrorAlert message={error} />
					<div className="pt-2">
						<button type="submit" disabled={loading} className="rounded-xl bg-sedra px-4 py-2.5 text-sm font-semibold text-white hover:bg-sedra-700 disabled:opacity-60 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-sedra">
							{loading ? 'Saving…' : 'Save and continue'}
						</button>
					</div>
				</form>
			</div>
		</Layout>
	);
} 